import React from "react";

import "./Accordion.css";

const Label = ({ text = "... text" }) => {
    return (
        <div className="scenario_label_container">
            <span className="material-symbols-outlined scenario_label_icon">label</span>
            <small className="scenario_label_paragraph">{text}</small>
        </div>
    );
};

export default Label;
